import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Lang } from '../../types/cart';
export function LangSwitch({
  className = ''
}: {
  className?: string;
}) {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div role="group" aria-label="Language" className={`flex rounded-md border mf-hairline p-0.5 ${className}`} data-id="element-452" data-mp="3jx8z7hg93ybj">
      {(['en', 'es'] as Lang[]).map(l => <button key={l} type="button" aria-pressed={lang === l} onClick={() => setLang(l)} className={`h-8 rounded px-2.5 text-[12px] font-semibold uppercase tracking-wider transition-colors duration-150 ${lang === l ? 'bg-white/10 text-white' : 'text-titanium hover:text-white'}`} data-id="element-453" data-mp="gefr3k68s1or">
          {l}
        </button>)}
    </div>;
}